import React, { useEffect } from "react";
import ReactDOMServer from "react-dom/server";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import formatContentfulRichText from "@qlik/qlik/src/lib/format-rich-text-content";
import { svgAnimations } from "./animation.svg";
import * as styles from "./styles.module.css";

const popoverContentRender = (data, className) => {
    return (
        <div className={`rich-text-body ${className}`}>
            {data.body?.raw && renderRichText(data?.body, formatContentfulRichText())}
        </div>
    );
};

const AnimationPageWhy = ({ cardItems }) => {
    useEffect(() => {
        const popoverNamingArray = ["One", "Two", "Three", "Four", "Five"];

        // An array containing the defaults from 'animations.svg.js'
        const popoverDimensions = [
            {
                name: "One",
                transformX: "334.11318",
                transformY: "473.687186",
                width: "171",
                height: "65",
            },
            {
                name: "Two",
                transformX: "517.91",
                transformY: "20",
                width: "172",
                height: "65",
            },
            {
                name: "Three",
                transformX: "371.773303",
                transformY: "473.687186",
                width: "92",
                height: "65",
            },
            {
                name: "Four",
                width: "173",
                height: "65",
                transformX: "517.91",
                transformY: "20",
            },
            {
                name: "Five",
                transformX: "371.773303",
                transformY: "473.687186",
                width: "82",
                height: "65",
            },
        ];

        // Function to measure the width of a string with specified font family and size
        const measureTextWidth = (text, fontSize = "18px", fontFamily = "Inter", fontWeight = "400") => {
            // Create a hidden div element
            const div = document.createElement("div");
            // Apply styles to make it hidden and ensure it doesn't affect layout
            div.style.position = "absolute";
            div.style.visibility = "hidden";
            div.style.whiteSpace = "nowrap";
            div.style.fontSize = fontSize;
            div.style.fontFamily = fontFamily;
            div.style.fontWeight = "400";
            div.innerText = text;
            document.body.appendChild(div);

            // Get the width
            const width = div.offsetWidth;

            // Remove the hidden div
            document.body.removeChild(div);

            return width;
        };

        // This is to change the width of the popover to stretch with the content.
        const setPopoverStyles = (name, text = null) => {
            const popoverEl = document.getElementById(`popover${name}`);

            const popoverStyles = popoverDimensions.filter((dim) => dim.name === name)?.[0];

            if (popoverEl && popoverStyles) {
                let newWidth = popoverStyles.width;
                let newTransformX = popoverStyles.transformX;
                let newHeight = popoverStyles.height;
                let newTransformY = popoverStyles.transformY;

                // Adjust width based on textLength
                if (text !== null) {
                    // A basic calculation to determine the width
                    const tmpWidth = measureTextWidth(text) + 28;

                    // Only modify the width and transformX values if the new calculated width is greater than the default(hardcoded) width
                    if (tmpWidth > popoverStyles.width) {
                        // Adjust transformX to center the popover based on the new width
                        const widthDifference = tmpWidth - popoverStyles.width;
                        // Set the new width
                        newWidth = tmpWidth;
                        // Set the new transformX value
                        newTransformX = parseFloat(popoverStyles.transformX) - widthDifference / 2;
                    }
                }

                popoverEl.setAttribute("transform", `translate(${newTransformX} ${newTransformY})`);
                popoverEl.setAttribute("width", newWidth);
                popoverEl.setAttribute("height", newHeight);
            }
        };

        // Loop through cardItems to update popovers dynamically
        for (let i = 0; i < popoverNamingArray.length; i++) {
            const classNames = i === 3 ? `${styles.cardItems} ${styles.cardItemsTwoColumn}` : `${styles.cardItems}`;

            const popoverTitle = cardItems[i]?.title;
            const popoverSubtitle = cardItems[i]?.subtitle;
            const popoverContent = ReactDOMServer.renderToStaticMarkup(popoverContentRender(cardItems[i], classNames));

            document.getElementById(`popover${popoverNamingArray[i]}Title`).innerHTML = popoverTitle;
            document.getElementById(`popover${popoverNamingArray[i]}Subtitle`).innerHTML = popoverSubtitle;
            document.getElementById(`popover${popoverNamingArray[i]}Content`).innerHTML = popoverContent;

            setPopoverStyles(popoverNamingArray[i], popoverSubtitle);
        }
    }, [cardItems]);

    return <p className="svg-wrapper" dangerouslySetInnerHTML={{ __html: svgAnimations }} />;
};

export default AnimationPageWhy;
